import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  constructor(private snackBar: MatSnackBar) { }

  show(
    message: string,
    action: string = '',
    duration: number = 10000
  ) {
    const snackBarRef = this.snackBar.open(
      message,
      '✕',
      {
        duration,
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass:
          action.toLowerCase() === 'success'
            ? ['success-snackbar']
            : action.toLowerCase() === 'error'
              ? ['error-snackbar']
              : []
      }
    );

    snackBarRef.onAction().subscribe(() => {
      snackBarRef.dismiss();
    });
  }
}
